import styled from 'styled-components';
import { theme } from '../../../theme';

export const SubNavBottomDivider = styled.hr`
  height: 1px;
  margin: -1px;
  border: none;
  background-color: ${theme.colors.neutrals.solidGrays[6]};
  position: absolute;
  width: 100%;
  left: 0;
`;
